import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const Campuscare = () => {
  return (
    <>
      <div className="campuslogo">
        <Link to="https://www.mgmbcampuscare.in/" target="_blank">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/Campulogo.png"
              className="img-fluid float-end campus"
              alt="MGM bokaro"
            />
          </LazyLoad>
        </Link>
      </div>
    </>
  );
};

export default Campuscare;
